import { ACCOUNT_SERVICE_URI } from '@cores/constants/envConfig';
import PtHeaderWidgetCaseTime from '@patsnap-biz/header-widget-case-time';
import { psAxios } from '@patsnap/common-ps-http';
export const caseTimeService = (() => {
    const caseTimeService = new PtHeaderWidgetCaseTime.Service();
    caseTimeService.axios = psAxios;
    caseTimeService.accountServiceUrl = ACCOUNT_SERVICE_URI;
    return caseTimeService;
})();
